import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import { MatSelectModule } from '@angular/material/select';

@Component({
    selector: 'app-day-range-dropdown',
    templateUrl: './day-range-dropdown.component.html',
    styleUrls: ['./day-range-dropdown.component.scss'],
    imports: [
        MatSelectModule
    ]
})
export class DayRangeDropdownComponent implements OnInit {
  @Output() rangeChanged: EventEmitter<number> = new EventEmitter<number>();

  constructor() {
  }

  ngOnInit(): void {
  }

}
